/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything is generated locally — nothing is uploaded.`)
};

const es_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo se genera localmente — no se sube nada.`)
};

const de_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles wird lokal generiert — nichts wird hochgeladen.`)
};

const nl_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles wordt lokaal gegenereerd — er wordt niets geüpload.`)
};

const fr_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout est généré localement — rien n'est envoyé sur un serveur.`)
};

const it_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto viene generato localmente — niente viene caricato online.`)
};

const pt_br2_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo é gerado localmente — nada é enviado a servidores.`)
};

const pt_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo é gerado localmente — nada é enviado para nenhum servidor.`)
};

const ja_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてローカルで生成され、アップロードは一切行われません。`)
};

const zh_qr_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一切都在本地生成——不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_ex3", locale)
	if (locale === "en") return en_qr_ex3(inputs)
	if (locale === "es") return es_qr_ex3(inputs)
	if (locale === "de") return de_qr_ex3(inputs)
	if (locale === "nl") return nl_qr_ex3(inputs)
	if (locale === "fr") return fr_qr_ex3(inputs)
	if (locale === "it") return it_qr_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_qr_ex3(inputs)
	if (locale === "pt") return pt_qr_ex3(inputs)
	if (locale === "ja") return ja_qr_ex3(inputs)
	return zh_qr_ex3(inputs)
};